import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Input from '../input';

const BasicFormField = ({ name, label, placeholder, wrapperClass, inputClass, ...attributes }) => (
  <div className={wrapperClass}>
    <div className="c-label-new">{ label }</div>
    <Input
      name={name}
      className={cx('c-input', inputClass)}
      type="text"
      placeholder={placeholder}
      {...attributes}
    />
  </div>
  );

BasicFormField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  wrapperClass: PropTypes.string,
  inputClass: PropTypes.string,
};

BasicFormField.defaultProps = {
  wrapperClass: 'layout__item u-1/2-medium-and-up',
  inputClass: '',
};

export default BasicFormField;
